export enum LocalStorageKeys {
  PERSISTED_CREATOR_ID = 'selected-creator',
  UI_THEME = 'ui-theme',
  THEME = 'theme',
  SELECTED_VAULT_CATEGORY = 'selectedVaultCategory',
  CREATORHERO_APP_VERSION = 'creatorhero-app-version',
  CREATORHERO_APP_LAST_PUBLISHED_VERSION = 'creatorhero-app-last-published-version',
  ACCOUNTS = 'auth.accounts',
  AUTH_TOKEN = 'auth._token.local',
  REDIRECT_AFTER_LOGIN = 'redirectAfterLogin',
  FAN_MESSAGE = 'fanMessageData',
  CHATTING_INTRODUCTION_SHOWN = 'chatting-introduction-shown',
  CHATTING_INTRODUCTION_DIALOG_SHOWN = 'chatting-introduction-dialog-shown',
  SHOW_ALL_PERMISSIONS = 'showAllPermissions',
  SPECIAL_OFFER = '`shown-offer-',
  HELP_DESK_ARTICLES_VIEWED = 'helpDeskArticlesViewed',
  // %s - placeholder for userId
  NSFW_FILTER = 'blur-enabled-%s',
}

export enum SessionStorageKeys {
  INITIALIZED = 'initialized',
}
